/**
 *
 * DivisionOrgTable
 *
 */

import React from "react"
import PropTypes from "prop-types"

import { uniq, truncate,get } from "lodash"
import { Table, Button, Tooltip } from "antd"
import { Icon } from "@ant-design/compatible"
import editArrow from "../../images/editarrow.svg"
import varrow from "../../images/varrow.svg"
import expandSvg from "../../images/expand.svg"
import collapse from "../../images/collapse.svg"
import deleteSvg from "../../images/delete.svg"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import { withRouter } from "react-router-dom"


import "./index.less"
/* eslint-disable react/prefer-stateless-function */

import RadioButtonDivision from "components/RadioButtonDivision"
import DOMPurify from 'dompurify';
import { DownloadOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons"

let lastItems = []
const grandparents = {}

class DivisionOrgTable extends React.Component {
  state = {
    selectedRowKeys: [],
    expandedRows: [],
  }

  componentDidMount = () => {
    if (this.props.first) {
      this.props.getDivisions({ params: "", first: this.props.first })
    } else {
      this.props.getDivisions({ params: "" })
    }

    // this.props.changeExpandedRows(this.props.expandedRows)
  }

/*   onSelectChange = (selectedRowKeys) => {
    this.setState({  selectedRowKeys: selectedRowKeys.data })
    console.log('selectedRowKeys',selectedRowKeys);
    if (selectedRowKeys.length) {
      this.props.toggleModal("buttonDeleteDivisions", true)
    } else {
      this.props.toggleModal("buttonDeleteDivisions", false)
    }

  } */

  getPadding = (level) => {
    let total = 0
    if (level == 1) {
      return total
    }

    for (let j = 0; j < level - 1; j++) {
      total += 20
    }

    return total
  }

  getBox = (level) => {
    let total = 0

    if (level == 1) {
      return total
    }

    for (let j = 0; j < level - 1; j++) {
      total += 1
    }

    return total
  }

  render() {
    const { selectedRowKeys } = this.state
    const { lastOfTree } = this.props

    const columns = [
      {
        title: "División",
        dataIndex: ["data", "division"],
        width: 350,
        key: "data.division",
        className: "wBorder",
        render: (text, record) => {
          const lineTHtml =
            "<div class='measurement-select-recipient-table-line-t'></div>" /* USADO */
          const lineLHtml =
            "<div class='measurement-select-recipient-table-line-l'></div>" /* USADO */

          let divs = ""

          if (record.children.length) {
            lastItems = uniq([
              ...lastItems,
              record.children[record.children.length - 1].data.id_division,
            ])
          }

          if (record.data.level === 1) {
            grandparents[record.data.id_division] = ""
          }

          if (
            lastItems.includes(record.data.id_division) &&
            record.data.level > 1
          ) {
            divs =
              (grandparents[record.data.id_parent] ?? "").replace(/e-t/g, "e") +
              lineLHtml
            grandparents[record.data.id_division] = divs
          }

          if (
            record.data.level > 1 &&
            !lastItems.includes(record.data.id_division)
          ) {
            divs =
              (grandparents[record.data.id_parent] ?? "").replace(/e-t/g, "e") +
              lineTHtml
            grandparents[record.data.id_division] = divs
          }

          if (
            lastItems.includes(record.data.id_parent) &&
            !lastItems.includes(record.data.id_division)
          ) {
            divs =
              (grandparents[record.data.id_parent] ?? "").replace(
                /line-l/g,
                "linelast"
              ) + lineTHtml
            grandparents[record.data.id_division] = divs
          }

          if (
            lastItems.includes(record.data.id_parent) &&
            lastItems.includes(record.data.id_division)
          ) {
            divs =
              (grandparents[record.data.id_parent] ?? "").replace(
                /line-l/g,
                "linelast"
              ) + lineLHtml
            grandparents[record.data.id_division] = divs
          }

          const sanitizedHTML = DOMPurify.sanitize(divs);
          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              {record.data.level !== 1 && (
                <div
                  style={{ display: "flex" }}
                  dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
                />
              )}
              <Tooltip title={text}>{truncate(text, { length: 40 })}</Tooltip>
            </div>
          )
        },
      },
      {
        title: "Colaboradores",
        width: 160,
        dataIndex: ["data", "employees"],
        key: "data.employees",
      },
      {
        title: "Nivel",
        width: 160,
        dataIndex: ["data", "level"],
        key: "data.level",
      },
      {
        title: "Subdivisiones",
        dataIndex: ["data", "subdivisions"],
        className: "example",
        width: 160,
        key: "data.subs",
        render: (text, record) => {
          return (
            <span data-haschildren={Boolean(record.children.length)}>
              {text}
            </span>
          )
        },
      },
    ]

   /*  const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    } */
      const hasFreshchat =
      typeof window.Intercom !== "undefined" &&
      window.self === window.top;
    return (
      <div className={`DivisionOrgContainer`}>
        <div className="orgButtons">
          <RadioButtonDivision
            tableView={this.props.tableView}
            toggleTableView={this.props.toggleTableView}
            toggleModal={this.props.toggleModal}
            rows={get(this.props.rowSelection, "selectedRowKeys", [])}
          />
          <Tooltip placement="top" title="Expandir divisiones">
            <Button
              className="ecButton"
              size="default"
              onClick={() => {
                this.props.changeExpandedRows(
                  this.props.data.data.map((item) => item.id_division)
                )
                // this.setState({
                //   expandedRows:
                // })
              }}>
              <img src={expandSvg} />
            </Button>
          </Tooltip>
          <Tooltip placement="topRight" title="Comprimir divisiones">
            <Button
              className="ecButton"
              size="default"
              onClick={() => {
                this.props.changeExpandedRows([])
              }}>
              <img src={collapse} />
            </Button>
          </Tooltip>
          {this.props.hasDivisions && (
            <div className="buttonsDivisions">
              <Button
                type="primary"
                className="removeTableButton"
                style={{
                  display: this.props.buttonDeleteDivisions
                    ? "flex"
                    : "none",
                }}
                onClick={() =>
                  this.props.toggleModal("modalDeleteDivisions", true)
                }>
                <img src={deleteSvg} />
                Eliminar
              </Button>
              <Tooltip placement="top" title="Crear división">
                <Button
                  className="blueButton createDivisionButton"
                  size="default"
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    woopraTrack("Crear división")
                    this.props.toggleCreateModal(true)
                  }}
                />
              </Tooltip>
              <Tooltip placement="top" title="Importar divisiones">
                <Button
                  className="whiteButton"
                  size="default"
                  icon={<UploadOutlined />}
                  onClick={() => {
                    woopraTrack("Importar divisiones")
                    this.props.history.push(
                      "/organization/divisions/import"
                    )
                  }}
                />
              </Tooltip>
              <Tooltip placement="topRight" title="Exportar divisiones">
                <Button
                  className="whiteButton"
                  size="default"
                  icon={<DownloadOutlined />}
                  onClick={() => {
                    woopraTrack("Exportar divisiones")
                    this.props.getTemplateDivision(false)
                  }}
                />
              </Tooltip>
            </div>
          )}
        </div>
        <Table
          className="division-org-table"
          rowClassName={(record) =>
            record.children.length ? "" : "hasnochildren"
          }
          rowSelection={this.props.rowSelection}
          expandIconColumnIndex={5}
          expandedRowKeys={this.props.expandedRows}
          columns={columns}
          loading={this.props.isLoading}
          onExpandedRowsChange={(rows) => this.props.changeExpandedRows(rows)}
          dataSource={this.props.treeData}
          rowKey={(record) => record.data.id_division}
          bordered
          size="small"
        />
      </div>
    )
  }
}

DivisionOrgTable.propTypes = { data: PropTypes.object || PropTypes.array }

export default withRouter(DivisionOrgTable)
